import uk.co.nickthecoder.kyd.Actor
import uk.co.nickthecoder.kyd.Behaviour

class SpawnPoint : Behaviour {

    override fun onEnteredStage(actor: Actor) {
        PlayDirector.instance.addSpawnPoint(actor.position)
        // We've done our job, now die.
        actor.parent.removeActor(actor)
    }

}
